import { site } from './helper/vars.js';

export function addJsToHtml() {
	if (site.classList.contains('no-js')) {
		site.classList.remove('no-js');
		site.classList.add('js');
	}
}